import getMatchedCSSRules from './getMatchedCSSRules';

const getCSSFromSVG = (svg: SVGSVGElement) : string => (svg ? [].slice.call(svg.querySelectorAll('*'))
  .reduce((accumulator, element) => accumulator + getMatchedCSSRules(element), '') : '');

export default getCSSFromSVG;
